import queryString, { ParseOptions } from 'query-string';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { DefaultQueryParams, GenericQueryParams } from '@/hooks/queryParams/types/QueryParams';

/**
 * Options can be useful. IE `{ parseBooleans: true, parseNumbers: true }`
 * @see https://www.npmjs.com/package/query-string
 */
export const useGetQueryParams = <QueryParams extends GenericQueryParams = DefaultQueryParams>() => {
    const { search } = useLocation();

    return React.useCallback(
        (options?: ParseOptions): QueryParams => {
            try {
                return queryString.parse(search.substring(1), options) as QueryParams;
            } catch {
                // Handle malformed URLs (e.g., invalid percent encoding like %V instead of %20)
                return {} as QueryParams;
            }
        },
        [search]
    );
};
